module.exports = __webpack_public_path__ + "media/images/icons-e1926f465dbef682b948e89968d31f8e.svg";